import { PlatformSDKShape } from '../PlatformSDKShape';
import { BaseSDKShape } from '../BaseSDKShape';

export class ApplicationSDKShape extends BaseSDKShape {
  async getPrivateAPI<T>() {
    return (await this.getApplicationContext()).getPrivateApplicationAPI() as T;
  }

  async getPublicAPI<T>(appDefinitionId: string) {
    const privateAPI = await this.getPlatformPrivateAPI();

    return privateAPI.applicationManager.getPublicApplicationAPI(
      appDefinitionId,
    ) as Promise<T>;
  }

  async getAppInstance() {
    const privateAPI = await this.getPlatformPrivateAPI();
    return privateAPI.info.getAppInstance(await this.getAppDefinitionId());
  }
}

export default new PlatformSDKShape(ApplicationSDKShape)
  .withPublicMethod('getPrivateAPI')
  .withPublicMethod('getPublicAPI')
  .withPublicMethod('getAppInstance')
  .build();
